import { styled } from "@octopus-energy/coral-design/jsx"
import { token } from "@octopus-energy/coral-design/tokens"

export const StickyWrapper = styled("div", {
    base: {
        position: "fixed",
        right: "0",
        bottom: "40px",
        width: "320px",
        overflow: "hidden",
        zIndex: 20,
        pointerEvents: "none",
    },
})

export const CardWrapper = styled("div", {
    base: {
        position: "relative",
        cursor: "pointer",
        width: "300px",
        marginRight: "20px",
        pointerEvents: "auto",
    },
})

export const PeekOverlay = styled("div", {
    base: {
        position: "absolute",
        inset: "0",
        borderRadius: "12px",
        background: "#2D1A83",
        opacity: 0,
        transition: "opacity 0.1s ease-out",
        pointerEvents: "none",
        zIndex: 2,
    },
    variants: {
        isPeeked: {
            true: { opacity: 1 },
        },
    },
})

export const DismissButtonWrapper = styled("div", {
    base: {
        position: "absolute",
        top: "0",
        right: "8px",
        zIndex: 1,
    },
})

export const MobileContainer = styled("div", {
    base: {
        backgroundColor: token("colors.background.secondary.900"),
        padding: token("spacing.xs"),
        width: "100%",
    },
})
